import { Record } from 'immutable';

const TransactionRecord = Record({
  eventId: null,
  firstName: null,
  lastName: null,
  roomRate: null,
  roomRateCurrency: null,
  checkInDate: null,
  checkOutDate: null,
  roomType: null,
  confirmation: null,
  nights: null,
  revenue: null,
  commission: null,
  commissionPercentage: null,
  eventReservationId: null,
  status: null,
  source: null,
  eventRsvpId: null,
  chainCode: null,
  brandCode: null,
  property: null,
  ratePlanCode: null,
  paymentRecordNumber: null,
  rooms: null,
  roomNights: null,
  groupCode: null,
  payViaGp: true
});

export class Transaction extends TransactionRecord {
  confirmation: string;
  firstName: string;
  lastName: string;
  checkInDate: string;
  checkOutDate: string;
  nights: number;
  roomType: string;
  roomRate: number;
  revenue: number;
  commission: number;
  commissionPercentage: number;
  eventId: number;
  roomRateCurrency: string;
  payViaGp: boolean;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/transaction.ts